// extracted by mini-css-extract-plugin
module.exports = {"spinner":"TimeToRead_spinner__GtnZf"};